import React from "react";
import { Link } from "react-router-dom";
import "./LightButton.css";

const LightButton = ({
  children,
  to,
  onClick,
  type = "button",
  disabled = false,
  className = "",
  style,
  title,
  ariaLabel,
  icon, // React node icon
  iconSrc, // string path to image icon
  iconPosition = "left", // 'left' | 'right'
}) => {
  const isIconOnly = (icon || iconSrc) && !children;
  const classes = `ui-btn${disabled ? " is-disabled" : ""}${
    isIconOnly ? " ui-btn--icon-only" : ""
  }${className ? " " + className : ""}`;

  const IconEl =
    icon || iconSrc ? (
      <span className="ui-btn__icon" aria-hidden="true">
        {icon ? (
          icon
        ) : (
          <img className="ui-btn__icon-img" src={iconSrc} alt="" />
        )}
      </span>
    ) : null;

  const LabelEl = children ? (
    <span className="ui-btn__label">{children}</span>
  ) : null;

  const contents =
    iconPosition === "right" ? (
      <>
        {LabelEl}
        {IconEl}
      </>
    ) : (
      <>
        {IconEl}
        {LabelEl}
      </>
    );

  const CapLeft = (
    <span className="ui-btn__cap ui-btn__cap--left" aria-hidden="true" />
  );
  const CapRight = (
    <span className="ui-btn__cap ui-btn__cap--right" aria-hidden="true" />
  );
  const Box = <span className="ui-btn__box">{contents}</span>;

  if (to && !disabled) {
    return (
      <Link
        to={to}
        className={classes}
        style={style}
        aria-disabled={disabled}
        title={title}
        aria-label={ariaLabel}
      >
        {CapLeft}
        {Box}
        {CapRight}
      </Link>
    );
  }

  return (
    <button
      type={type}
      onClick={disabled ? undefined : onClick}
      className={classes}
      disabled={disabled}
      style={style}
      title={title}
      aria-label={ariaLabel}
    >
      {CapLeft}
      {Box}
      {CapRight}
    </button>
  );
};

export default LightButton;
